import axios from "axios";
import baseUrl from "./baseUrl";
import { decryptData } from "../utils/decryptor";
import { generateSecureRandomString } from "../utils/randomValueCrypto";

axios.defaults.withCredentials = true;

/**** Login ****/
export const login = (data) => {
  const loginUserURL = baseUrl.base_url + "/login";
  const response = axios.post(loginUserURL, data);
  // localStorage.setItem("email", data.username);
  return response;
};

/**** Concurrent Login Confirmation ****/
export const confirmConcurrentLogin = (data) => {
  const confirmLoginURL = baseUrl.base_url + "/login/confirm-concurrent";
  const response = axios.post(confirmLoginURL, data);
  return response;
};

/**** Forgot password ****/
export const forgotPassword = (data) => {
  const resetPasswordLink = `${baseUrl.frontendUrl}/reset-password`;
  const apiUrl = `${baseUrl.base_url}/forgot-password`;
  const response = axios.post(apiUrl, {
    username: data.username,
    resetPasswordLink,
  });
  return response;
};

/**** Reset password ****/
export const resetPassword = (data) => {
  const apiUrl = `${baseUrl.base_url}/reset-password`;
  const response = axios.post(apiUrl, data);

  return response;
};

export const fetchDisplayName = async (data) => {
  const fetchNameURL = `${baseUrl.base_url}/fetch-display-name`; // Ensure baseUrl.base_url is defined and correct
  try {
    const response = await axios.post(fetchNameURL, data);
    return response; // Return the full response object for detailed handling
  } catch (error) {
    console.error("Error fetching display name from API:", error);
    throw error; // Re-throw error for handling in the caller
  }
};

/***** LOG OUT *****/
export const logout = () => {
  localStorage.clear();
  return axios.get(`${baseUrl.base_url}/logout`);
};

/***** Admin Login *****/
export const adminLogin = (data) => {
  return axios.post(`${baseUrl.base_url}/admin/login`, data);
};

/***** Get All users *****/
export const getAllUsers = (data) => {
  return axios.post(`${baseUrl.base_url}/QMentisAdminGateway/getUsers`, data);
};

export const getFiltertedCapablity = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisAdminGateway/get-capability-filtering`,
    data
  );
};

export const getprojectsFiltering = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisAdminGateway/get-projects-filtering`,
    data
  );
};

export const getBasicTopUsers = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisAdminGateway/basicTopUsers`,
    data
  );
};

export const getBasicTopProjects = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisAdminGateway/basicTopProjects`,
    data
  );
};

// /***** Get All Projects by Admin *****/
export const getAllProjectsByAdmin = () => {
  return axios.post(`${baseUrl.base_url}/QMentisAdminGateway/getProjects`);
};

export const getAllCapabilities = () => {
  return axios.post(`${baseUrl.base_url}/QMentisAdminGateway/getCapabilities`);
};
/*****CREATE USERS BY ADMIN *****/
export const createUser = async (data) => {
  const addUserApi = baseUrl.base_url + "/QMentisAdminGateway/create/user";
  // const reset_password_link = `${baseUrl.frontendUrl}/reset-password`;
  const {
    username,
    password,
    displayName,
    designation,
    divisionalUnit,
    ProjectID,
  } = data;

  const response = await axios.post(addUserApi, {
    username,
    password,
    displayName,
    designation,
    divisionalUnit,
    ProjectID,
  });
  return response;
};

// /*****CREATE PROJECT BY ADMIN *****/
export const createProject = async (data) => {
  const addProjectApi =
    baseUrl.base_url + "/QMentisAdminGateway/create/project";
  const { projectName } = data;
  const response = await axios.post(addProjectApi, { projectName });
  return response;
};

/***** Delete Users *****/
export const deleteUser = (data) => {
  const deleteUserApi = `${baseUrl.base_url}/QMentisAdminGateway/delete/user/${data}`;
  return axios.delete(deleteUserApi);
};

/***** Delete Projects *****/
export const deleteProject = (data) => {
  const deleteProjectApi = `${baseUrl.base_url}/QMentisAdminGateway/delete/project/${data}`;
  return axios.delete(deleteProjectApi);
};

/***** Edit Users *****/
export const editUser = (data) => {
  return axios.put(
    `${baseUrl.base_url}/QMentisAdminGateway/edit/user/${data.id}`,
    {
      display_name: data.displayName,
      project_id: data.project_id,
      designation: data.designation,
      divisionalUnit: data.divisionalUnit,
    }
  );
};

// admin dashboard chart 1 api
export const dashBoardData1 = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-dashboard-data1`;
  const chartResult = axios.post(dashboard1Url, data);
  return chartResult;
};

// admin dashboard chart 2 api
export const dashBoardData2 = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-dashboard-data2`;
  const chartResult = axios.post(dashboard1Url, data);
  return chartResult;
};

export const basic2ngGraphData = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-basic2ndGraph`;
  const basicchartResult = axios.post(dashboard1Url, data);
  return basicchartResult;
};

export const basic3rdGraphData = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-basic3rdGraph`;
  const ThirdbasicchartResult = axios.post(dashboard1Url, data);
  return ThirdbasicchartResult;
};

// admin dashboard chart 3 api
export const dashBoardData3 = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-dashboard-data3`;
  const chartResult = axios.post(dashboard1Url, data);
  return chartResult;
};

// admin dashboard chart 4 api
export const dashBoardData4 = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-dashboard-data4`;
  const chartResult = axios.post(dashboard1Url, data);
  return chartResult;
};

export const getServiceRequest = (data) => {
  const dashboard1Url = `${baseUrl.base_url}/QMentisAdminGateway/get-service-request`;
  const chartResult = axios.post(dashboard1Url, data);
  return chartResult;
};

export const sessionValidation = async () => {
  const validationUrl = `${baseUrl.base_url
    }/sessionPing/${generateSecureRandomString(16)}`;

  try {
    const validationResult = await axios.get(validationUrl, {
      headers: { "Content-Type": "application/json" },
    });

    return await decryptData(validationResult.data);
  } catch (error) {
    throw error; // Return `null` for cases with no response data
  }
};

export const modifyTestCaseData = async (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/modify-testcase-data";
  const response = await axios.post(apiUrl, { inputData: data });
  return response;
};
export const modifyBugData = async (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/modify-bug-data";
  const response = await axios.post(apiUrl, { inputData: data });
  return response;
};

export const modifyUserStoryData = async (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/modify-userstory-data";
  const response = await axios.post(apiUrl, { inputData: data });
  return response;
};

/***** Scrutinize api for bug report enhancement *****/

export const freeFlowBugReportEnhance = async (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/freeFlowScrutinize`;
  try {
    const freeFlowEnhacedReport = await axios.post(apiUrl, data);
    return freeFlowEnhacedReport;
  } catch (error) {
    throw error; // Propagate the error if needed
  }
};

export const scrutinize = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/scrutinizeService`;
  const enhancedReport = axios.post(apiUrl, data);

  return enhancedReport;
};

/***** Investigate api *****/
export const freeFlowInvest = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/freeflowInvestigateService";
  const response = axios.post(apiUrl, data);
  return response;
};

export const validateUserInput = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/inputInvestigateService";
  const response = axios.post(apiUrl, data);
  return response;
};

export const investigate = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/investigateService";
  const response = axios.post(apiUrl, data);
  return response;
};

export const userstoryEvaluation = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/commonEvaluation";
  const response = axios.post(apiUrl, data);
  return response;
};

export const refinedUserstory = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/refineUserStory";
  const response = axios.post(apiUrl, data);
  return response;
};
//added
export const refineUserStoryWithRAG = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/refineUserStoryWithRAG";
  return axios.post(apiUrl, data);
};

export const userStoryToTestScenarios = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/userStoryToTestScenarios";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** Invest api *****/
export const invest = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/investService";
  const response = axios.post(apiUrl, data);
  return response;
};

export const refinedUserstories = () => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/refineUserStories";
  const response = axios.post(apiUrl);
  return response;
};

/**** GenTest api ****/
export const userStoryToUseCase = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/genTestUseCase";
  const response = axios.post(apiUrl, data);
  return response;
};

export const businessProcessGuide = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/businessProcessGuide";
  const response = axios.post(apiUrl, data);
  return response;
};

export const genTestCases = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/genTestCases";
  const response = axios.post(apiUrl, data);
  return response;
};

/**** UseCase2TestCase api ****/
export const generateTestCases = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/useCase2TestCaseService";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateTestCasesUsingFSDAndUseCase = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-testcases-fsdandusecases";
  const response = axios.post(apiUrl, data);
  return response;
};
/**** Test Design api ****/
export const generateFSD = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/userStoryToFSD";
  const response = axios.post(apiUrl, data);
  return response;
};

export const finalbrd = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/finalBRD";
  const response = axios.post(apiURL, data);
  return response;
};

export const finalbrdFromUserStory = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/finalBRDFromUserStory";
  const response = axios.post(apiURL, data);
  return response;
};

export const brdToFuncModule = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/BRDToFunctionalModule";
  const response = axios.post(
    apiURL,
    { brd: data },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const funcModToSecurityReq = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/FMToSecurityRequirements";
  const response = axios.post(
    apiURL,
    { funcModules: data },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const brdToArchDesign = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/BRDToArchitectureDesign";
  const response = axios.post(apiURL, data);
  return response;
};

export const secRecommendations = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/SecurityRecommendations";
  const response = axios.post(apiURL, data);
  return response;
};

export const fmTothreatModelling = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/ThreatModelling";
  const response = axios.post(apiURL, data);
  return response;
};

export const addToaddReview = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/ADDReview";
  const response = axios.post(apiURL, data);
  return response;
};

export const securityPlan = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/SecurityTestPlan";
  const response = axios.post(apiURL, data);
  return response;
};

export const sastPlan = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/SastTestPlan";
  const response = axios.post(apiURL, data);
  return response;
};

export const dastPlan = (data) => {
  const apiURL = baseUrl.base_url + "/QMentisGateway/DastTestPlan";
  const response = axios.post(apiURL, data);
  return response;
};


export const generateTraceabilityMatrix = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/traceabilityMatrix";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateTestConditions = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/testConditions";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateTestTechniques = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/selectTestingTechniques";
  const response = axios.post(apiUrl, data);
  return response;
};

/**** Globa configuration ****/
export const getGlobalConfig = () => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-global-config";
  const response = axios.get(apiUrl);
  return response;
};
/**** ****/

/**** Jira calls ****/

export const createCustomFields = () => {
  const apiUrl = baseUrl.base_url + "/create-custom-fields";
  const response = axios.post(apiUrl);
  return response;
};

export const getAllProjects = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/get-jira-projects" +
    `?config_id=${data?.config_id}`;
  const response = axios.get(apiUrl);
  return response;
};

export const getAllJiraFields = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-jira-available-fields";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getAllEpics = (projectKey) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-jira-epics";
  const response = axios.post(apiUrl, { projectKey });
  return response;
};

export const getUnassignedStories = (
  projectName,
  projectKey,
  issueType = "Story"
) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-unassigned-stories";
  const response = axios.post(apiUrl, { projectName, projectKey, issueType });
  return response;
};

export const getAllSprints = (projectKey) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-sprints-under-project";
  const response = axios.post(apiUrl, { projectKey });
  return response;
};

export const getUserStoriesUnderEpic = (projectName, epicKey, mapping) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-userstories-under-epic";
  const response = axios.post(apiUrl, { projectName, epicKey, mapping });
  return response;
};

export const getUserStoriesUnderSprint = (projectName, sprintId, mapping) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-userstories-under-sprint";
  const response = axios.post(apiUrl, { projectName, sprintId, mapping });
  return response;
};

export const getJiraStatusesForFilters = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-statuses-under-project";
  const response = axios.post(apiUrl, data);
  return response;
};

export const createJiraIssues = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/create-jira-issue";
  const response = axios.post(apiUrl, data);
  return response;
};

export const updateJiraIssues = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-jira-issue";
  const response = axios.post(apiUrl, data);
  return response;
};
/**************** Tool Mapping *********************/
export const getToolMapping = async (params) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/get-tool-mapping?tool=${params.tool}&tool_url=${params.tool_url}&project_name=${params.project_name}&issue_type=${params.issue_type}&task_type=${params.task_type}`;
  const response = await axios.get(apiUrl);
  return response;
};

export const saveToolMapping = (mappingData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/save-tool-mapping";
  const response = axios.post(apiUrl, mappingData);
  return response;
};

export const updateToolMapping = (mappingData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-tool-mapping";
  const response = axios.put(apiUrl, mappingData);
  return response;
};

export const deleteToolMapping = (toolmapping_id) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/delete-tool-mapping`;
  const response = axios.delete(apiUrl, {
    data: { toolmapping_id: toolmapping_id },
  });
  return response;
};

/**************** Admin Configuration ***************/
export const getAdminConfig = (params) => {
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/get-admin-config?tool=${params.tool}`;
  const response = axios.get(apiUrl);
  return response;
};

export const saveAdminConfig = (configData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/save-admin-config";
  const response = axios.post(apiUrl, configData);
  return response;
};

export const updateAdminConfig = (configData) => {
  console.log("configData in webService", configData);
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-admin-config";
  const response = axios.put(apiUrl, configData);
  return response;
};

export const deleteAdminConfig = (config_id) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/delete-admin-config?config_id=${config_id}`;
  const response = axios.delete(apiUrl);
  return response;
};

/************* User Configuration **************************/
export const getUserConfig = (params) => {
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/get-user-config?tool=${params.tool}`;
  const response = axios.get(apiUrl);
  return response;
};

export const saveUserConfig = (configData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/save-user-config";
  const response = axios.post(apiUrl, configData);
  return response;
};

export const updateUserConfig = (configData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-user-config";
  const response = axios.put(apiUrl, configData);
  return response;
};

export const deleteUserConfig = (tool) => {
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/delete-user-config?tool=${tool}`;
  const response = axios.delete(apiUrl);
  return response;
};

/************* Field Mapping ****************/
export const getFieldMapping = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-field-mapping";
  const response = axios.post(apiUrl, data);
  return response;
};

export const saveFieldMapping = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/save-field-mapping";
  const response = axios.post(apiUrl, data);
  return response;
};

/************* Test Rail *******************/
// export const storeTestRailConfig = (data) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/save-testrail-configuration`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };

// export const getTestRailConfig = () => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/get-testrail-config-details`;
//   const response = axios.get(apiUrl);
//   return response;
// };

export const getAllTestRailProjects = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/get-testrail-projects" +
    `?config_id=${data?.config_id}`;
  const response = axios.get(apiUrl);
  return response;
};

export const getCaseTemplatesFromTestRail = (project_id, config_id) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-testrail-templates`;
  const response = axios.post(apiUrl, { project_id: project_id, config_id });
  return response;
};
export const getTestCaseFieldsFromTestRail = (
  template_id,
  project_id,
  config_id
) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-testrail-fields`;
  const response = axios.post(apiUrl, {
    template_id: template_id,
    project_id: project_id,
    config_id,
  });
  return response;
};

export const getTestSuitesByProjectID = (project_id) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-testrail-suites`;
  const response = axios.post(apiUrl, { project_id: project_id });
  return response;
};

export const getSectionsByProjectAndSuite = (project_id, suite_id) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-testrail-sections`;
  const response = axios.post(apiUrl, {
    project_id: project_id,
    suite_id: suite_id,
  });
  return response;
};

export const addTestCaseToTestRail = (payload) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/add-testrail-testcases`;
  const response = axios.post(apiUrl, payload);
  return response;
};

/************* Confluence *******************/
// export const storeConfluenceConfig = (data) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/save-confluence-configuration`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };

// export const getConfluenceConfigToDB = () => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/get-confluence-config-details`;
//   const response = axios.get(apiUrl);
//   return response;
// };

export const getAllConfluenceSpaces = () => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-confluence-spaces`;
  const response = axios.get(apiUrl);
  return response;
};

export const getAllConfluencePages = (payload) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/get-confluence-pages`;
  const response = axios.post(apiUrl, payload);
  return response;
};

export const addPageToConfluence = (payload) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/add-confluence-pages`;
  const response = axios.post(apiUrl, payload);
  return response;
};

export const overwriteConfluencePage = (payload) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/overwrite-confluence-page`;
  const response = axios.put(apiUrl, payload);
  return response;
};

export const confluenceContentAnalysis = async (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/confluence-content-bug-analysis";
  const response = await axios.post(apiUrl, { inputData: data });
  return response;
};
////////////////////////////////////// FILTER ISSUE //////////////////////////////////////////////

export const getFilteredBugs = (filters) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-filtered-issues";
  return axios.post(apiUrl, filters);
};

////////////////////////////////////// FILTER ISSUE //////////////////////////////////////////////

export const exportUserStoryToJira = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-user-story-in-jira";
  return axios.post(apiUrl, data);
};

export const exportBugReportToJira = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-bugs-in-jira";
  return axios.post(apiUrl, data);
};
////////////////////////////////////// Project Version //////////////////////////////////////////////

export const getProjectVersions = (projectKey) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/project/${projectKey}/versions`;
  return axios.get(apiUrl);
};

////////////////////////////////////// Project Version //////////////////////////////////////////////

export const createJiraIssueApiCall = (data) => {
  const apiUrl = baseUrl.base_url + "/create-jira-issue";
  const response = axios.post(apiUrl, data);
  return response;
};

export const fetchJiraIssuesApiCall = (projectId) => {
  const apiUrl = baseUrl.base_url + `/jira-issues/${projectId}`; // Match the backend route
  const response = axios.get(apiUrl);
  return response;
};

export const importJiraIssueApiCall = (projectId, issueId) => {
  const apiUrl = baseUrl.base_url + `/import-jira-issue`;
  return axios.post(apiUrl, { projectId, issueId });
};

/***** Logger call *****/
export const logger = (level, message) => {
  const loggerApiUrl = baseUrl.loggerUrl;
  try {
    axios.post(loggerApiUrl, { level, message });
  } catch (error) {
    console.error("Error logging message:", error.message);
  }
};

/***** TestScape ******/
export const testScape = async (data) => {
  try {
    const apiUrl = baseUrl.base_url + "/QMentisGateway/testScape";
    const response = await axios.post(apiUrl, { userInput: data }); // Ensure data is wrapped in an object
    return response.data; // Return the response data
  } catch (error) {
    throw error; // Handle errors appropriately
  }
};

export const riskAssessment = async (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/riskAssessment`;
  const riskAssessResponse = await axios.get(apiUrl);
  return riskAssessResponse;
};

export const contingencySteps = async (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/contingencySteps`;
  const riskAssessResponse = await axios.get(apiUrl);
  return riskAssessResponse;
};

export const createTestCasesJiraIssue = async (data) => {
  const apiUrl = `${baseUrl.base_url}/create-testCases-jira-issue`;
  const createdIssue = await axios.post(apiUrl, {
    userStory: data.userStory,
    testCases: data.testCases,
  });
  return createdIssue;
};

export const fetchExistingJiraFieldsFromScreen = async () => {
  const apiUrl = `${baseUrl.base_url}/get-existing-jira-fields`;
  const fetchedFields = await axios.post(apiUrl);
  return fetchedFields;
};

// data should issue type with string type
export const fetchSpecificIssues = async (data) => {
  const apiUrl = `${baseUrl.base_url}/get-specific-jira-issues`;
  const fetchedSpecificFields = await axios.post(apiUrl, { issueType: data });
  return fetchedSpecificFields;
};

//////////////////  ADO ////////////////////////////

// export const getADOConfiguration = async () => {
//   const apiUrl = `${baseUrl.base_url}/QMentisGateway/get-ado-configuration`;
//   const adoConfig = await axios.get(apiUrl);
//   return adoConfig;
// };

// export const saveADOConfiguration = async (data) => {
//   const apiUrl = `${baseUrl.base_url}/QMentisGateway/save-ado-configuration`;
//   const savedADOConfig = await axios.post(apiUrl, data);
//   return savedADOConfig;
// };

export const getAllAdoProjects = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-projects" + `?config_id=${data?.config_id}`;
  const response = axios.get(apiUrl);
  return response;
};

export const getTeamsFromADO = (projectName) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-teams";
  const response = axios.post(apiUrl, { projectName });
  return response;
};

export const getEpicsUnderAdoProject = (projectName) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-epics";
  const response = axios.post(apiUrl, { projectName });
  return response;
};

export const getAllSprintsFromADO = (projectName, teamName) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-sprints";
  const response = axios.post(apiUrl, { projectName, teamName });
  return response;
};

export const getUnassignedStoriesFromADO = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-ado-unassigned-stories";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getTestCasesADO = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-test-cases";
  const response = axios.post(apiUrl, data);
  return response;
}

export const getFeaturesUnderEpic = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-features";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getUserStoriesUnderFeatures = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-userstories-under-feature";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getUserStoriesUnderSprintFromADO = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-userstories-under-sprint-ado";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getFilteredBugsFromADO = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-filtered-bugs";
  const response = axios.post(apiUrl, data);
  return response;
};

export const getADOAvailableFields = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-ado-fields";
  const response = axios.post(apiUrl, data);
  return response;
};

export const exportBackUserStoryToADO = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-user-story-in-ado";
  return axios.post(apiUrl, data);
};

export const exportBugReportToADO = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-bugs-in-ado";
  return axios.post(apiUrl, data);
};

export const updateADOIssueToADO = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-ado-issue";
  const response = axios.post(apiUrl, data);
  return response;
};

export const createADOIssueApiCall = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/create-ado-issue";
  const response = axios.post(apiUrl, data);
  return response;
};

////////////////// ----------- ADO ------------ ////////////////////////////

////////////////////// qTest /////////////////////////////

export const getqtestConfig = () => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-qtest-configuration";
  const response = axios.get(apiUrl);
  return response;
};
export const saveqtestConfiguration = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/save-qtest-configuration";
  const response = axios.post(apiUrl, data);
  return response;
};
export const WebScrappingWebPortal = (data) => {
  const apiUrl = baseUrl.base_url + `/QMentisGateway/WebScrappingAgent`;
  const response = axios.post(apiUrl, data);
  return response;
};
export const getqtestAllProjects = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/get-qtest-all-projects" +
    `?config_id=${data?.config_id}`;
  const response = axios.get(apiUrl);
  return response;
};

export const getqtestAllModules = (projectId) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-qtest-all-modules";
  const response = axios.get(apiUrl, { projectId });
  return response;
};

export const getqtestDefects = (projectId) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-qtest-defects";
  const response = axios.get(apiUrl, { projectId });
  return response;
};

export const getqtestTestCases = (projectId, moduleId) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-qtest-test-cases";
  const response = axios.get(apiUrl, { projectId, moduleId });
  return response;
};

export const updateDefectsInqtest = (projectId, bugsData, defectId = null) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-qtest-defects";
  return axios.post(apiUrl, { projectId, bugsData, defectId });
};

export const updateTestCasesInqtest = (
  projectId,
  projectName,
  testCaseData,
  testCaseId = null
) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/update-qtest-test-cases";
  return axios.post(apiUrl, {
    projectId,
    projectName,
    testCaseData,
    testCaseId,
  });
};

export const getqtestAllFields = async (projectId, objectType, config_id) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/get-qtest-fields";
  const response = await axios.post(apiUrl, {
    projectId,
    objectType,
    config_id,
  });
  return response.data;
};
///////////////// ------------ qTest -------------- //////////////////////

/******************************************/
/*******Automation Flow Starts Here********/
/******************************************/

/***** Feature File Generation ******/
export const featureFiles = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-feature";
  const response = axios.post(apiUrl, data);
  return response;
};

export const featureFilesWithToolCalling = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-feature-file";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** PseudoCode(codeskeleton) Generation ******/
export const pseudoCode = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-codeskeleton";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** PageSource(locators) Generation ******/
export const pageSourceService = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-locators";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** PageClass(pageClass) Generation ******/

export const pageClassAPI = (data, framework) => {
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/generate-pageClass-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const pageClassAPIWithToolCalling = (data, framework) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-pageClass-${framework}-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const playWrightCSharpStepDefinition = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-stepdefinition-playwright-c-sharp`;
  const response = axios.post(apiUrl, data);
  return response;
};

/***** stepDefinition(Automation Code) Generation ******/
export const stepDefinitionAPI = (data, framework) => {
  console.log(data, framework);
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/generate-stepDefinition-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const stepDefinitionAPIWithToolCalling = (data, framework) => {
  console.log("with tool calling");
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-stepDefinition-rest-assured-with-tool-calling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const stepDefinitionWithToolCallingAPI = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-stepDefinition-selenium-java-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const stepDefinitionWithToolCallingForPlaywright = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-stepDefinition-playwright-java-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

// Cypress JavaScript specific API functions
export const cypressTestFilesWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-cypress-testfiles";
  // For Cypress test file generation, pass testCaseData directly
  const requestData = data.testCaseData || data;
  const response = axios.post(apiUrl, requestData);
  return response;
};

export const cypressPageClassAPIWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-cypress-pageobjects";
  const response = axios.post(apiUrl, data);
  return response;
};

export const cypressProjectAPIWithToolCalling = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-cypress-project";
  const response = axios.post(apiUrl, data);
  return response;
};

export const cypressLocatorsAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-cypress-locators";
  const response = axios.post(apiUrl, data);
  return response;
};

// Playwright TypeScript specific API functions
export const playwrightTypeScriptLocatorsAPI = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-playwright-typescript-locators";
  const response = axios.post(apiUrl, data);
  return response;
};

export const playwrightTypeScriptPageObjectsAPI = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-playwright-typescript-pageobjects";
  const response = axios.post(apiUrl, data);
  return response;
};

export const playwrightTypeScriptTestFilesAPI = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-playwright-typescript-testfiles";
  const response = axios.post(apiUrl, data);
  return response;
};

export const playwrightTypeScriptProjectAPI = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-playwright-typescript-project";
  const response = axios.post(apiUrl, data);
  return response;
};

// Test Data Upload APIs for Playwright TypeScript
export const uploadTestDataAPI = (formData) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/upload-test-data";
  const response = axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

export const mavenProject = (data, framework) => {
  console.log(data, framework);
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/generate-mavenProject-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const mavenProjectWithToolCalling = (data, framework) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const playwrightCSharpSpecflowProjectWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-mavenProject-playwright-c-sharp-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};


// Playwright csharp reqnroll API
export const playwrightCSharpReqnrollPageClass = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-pageClass-playwright-csharp-reqnroll";
  const response = axios.post(apiUrl, data);
  return response;
}

export const playwrightCSharpReqnrollStepDefinition = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-stepdefinition-playwright-csharp-reqnroll";
  const response = axios.post(apiUrl, data);
  return response;
}

export const generatePlaywrightCSharpReqNRollProject = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/generate-playwright-csharp-reqnroll-project`;
  const response = axios.post(apiUrl, data);
  return response;
};


//
export const SeleniumCucumberProjectWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const SeleniumSpecflowProjectWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/generate-mavenProject-c-sharp`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const PlaywrightCucumberProjectWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-mavenProject-playwright-java-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const updateGitHubProject = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/update-github-project";
  const response = axios.post(apiUrl, data);
  return response;
};
export const modifiedTestCaseGitJavaSelenium = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/modified-testcase-github-project-selenium-java";
  const response = axios.post(apiUrl, data);
  return response;
};

export const updateGitHubProjectPlaywrightJava = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/update-github-project-playwright-java";
  const response = axios.post(apiUrl, data);
  return response;
};
export const modifiedTestCaseGitPlaywrightJava = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/modified-testcase-github-project-playwright-java";
  const response = axios.post(apiUrl, data);
  return response;
};

export const TestngJavaWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-mavenProject-selenium-java-testng-with-tool-calling";
  const response = axios.post(apiUrl, data);
  return response;
};

export const TestngJavaPageclassWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-pageClass-selenium-java-testng-with-tool-calling";
  const response = axios.post(apiUrl, data);
  return response;
};

export const TestngJavaTestMethodsWithToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url +
    "/QMentisGateway/generate-testmethods-selenium-java-testng-with-tool-calling";
  const response = axios.post(apiUrl, data);
  return response;
};

export const updateGitHubProjectRobotFramework = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/update-github-project-robot-framework";
  const response = axios.post(apiUrl, data);
  return response;
};

export const robotFilesService = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-robotFiles";
  const response = axios.post(apiUrl, data);
  return response;
};

export const robotFrameworkProject = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-robotFrameworkProject";
  const response = axios.post(apiUrl, data);
  return response;
};

export const validateGitCredentials = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/validate-git-credentials";
  const response = axios.post(apiUrl, data);
  return response;
};

export const validateBitbucketCredentials = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/validate-bitbucket-credentials";
  const response = axios.post(apiUrl, data);
  return response;
};

export const githubNewProjectCreation = (data) => {
  console.log(data, "service page");
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-newProject-Github";
  const response = axios.post(apiUrl, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const bitbucketNewProjectCreation = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-newProject-BitBucket";
  const response = axios.post(apiUrl, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const keyWordDesign = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generate-keyWordDesign";
  const response = axios.post(apiUrl, data);
  return response;
};

export const midLevelKeyWordDesign = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-midLevelKeyWordDesign";
  const response = axios.post(apiUrl, data);
  return response;
};

export const convertFreeFlowTextToUserStory = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-userStoryFromText";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** API TESTING  END POINT******/
export const generateTestCasesForAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generateTestCasesForAPI";
  const response = axios.post(apiUrl, data);
  return response;
};

// export const generateTestCasesForAPI = (data) => {
//   const apiUrl = baseUrl.base_url + "/QMentisGateway/generatetestcasesusingCAG";
//   const response = axios.post(apiUrl, data);
//   return response;
// };

export const manualDetails = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/APIDocumentation";
  const response = axios.post(apiUrl, data);
  return response;
};
export const CSharpPageClass = (data) => {
  const apiUrl = baseUrl.base_url + "/QEBotGateway/generate-CSharpPageClass";
  const response = axios.post(apiUrl, data);
  return response;
};

export const importExcelFileFormat = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/importExcelFileFormat";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateBaseURL = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generateBaseURL";
  const response = axios.post(apiUrl, data);
  return response;
};

export const ConnectingToGIT = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/connect-gitpath";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateFeatureFileForAPITesting = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/generateFeatureFileForAPI";
  const response = axios.post(apiUrl, data);
  return response;
};

export const generateFeatureFileToolCalling = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-feature-file-toolCalling";
  const response = axios.post(apiUrl, data);
  return response;
};

export const jsonPojoClass = (data, framework) => {
  console.log(data, "data");
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/pojoClasstWithToolCalling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};
export const pojoClasstWithToolCalling = (data, framework) => {
  console.log(data, "data");
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-pojoclass-with-tool-calling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const resourceChainTestCases  = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/resourceChainTestCases";
  const response = axios.post(apiUrl, data);
  return response;
}

export const xmlPojoClass = (data, framework) => {
  console.log(data, "data");
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/xmlPojoclassWithToolCalling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const xmlPojoclassWithToolCalling = (data, framework) => {
  console.log(data, "data");
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-xml-pojoclass-with-tool-calling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const swaggerToPostman = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/conversion-swagger-to-postman";
  const response = axios.post(apiUrl, data);
  return response;
};

export const apiDetailsToYAML = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/conversion-apidetails-to-openapi";
  const response = axios.post(apiUrl, data);
  return response;
};

export const APITraceabilityMatrix = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/traceabilityMatrixAPI";
  const response = axios.post(apiUrl, data);
  return response;
};

export const uploadTestCasesAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/uploadTestCasesAPI";
  const response = axios.post(apiUrl, data);
  return response;
};

export const endpoitnExtractionAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/endpointExtraction";
  const response = axios.post(apiUrl, data);
  return response;
};

export const htmlParsingForSwagger = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/htmlParsingForSwagger";
  const response = axios.post(apiUrl, data);
  return response;
};

export const apiStepDefinition = (data, framework) => {
  console.log(data, "data");
  const apiUrl =
    baseUrl.base_url + `/QMentisGateway/stepDefinitionApi-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const apiStepDefinitionToolCalling = (data, framework) => {
  // console.log("848");
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-stepDefinition-rest-assured-with-tool-calling-${framework}`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const testConnectionValidation = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/testConnection";
  const response = axios.post(apiUrl, data);
  return response;
};

export const payloadSchema = (data) => {
  console.log(data, "data");
  const apiUrl = baseUrl.base_url + "/QMentisGateway/payloadSchema";
  const response = axios.post(apiUrl, data);
  return response;
};

// export const CSharpPageClass = (data,framework) => {
//   console.log(data);
//   const apiUrl = baseUrl.base_url + `/QEBotGateway/generate-CSharpPageClass-${framework}`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };

export const CSharpStepDefinition = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QEBotGateway/generate-CSharpStepDefinition";
  const response = axios.post(apiUrl, data);
  return response;
};

export const CSharpProject = (data) => {
  const apiUrl = baseUrl.base_url + "/QEBotGateway/generate-CSharpProject";
  const response = axios.post(apiUrl, data);
  return response;
};

//GET JIRA BUGS BY ID
export const getJIRABugsByID = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/get-jira-filtered-bugs-by-ID";
  const response = axios.post(apiUrl, data);
  return response;
};

//File Upload API
export const uploadFile = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/uploadFile";
  const response = axios.post(apiUrl, data);
  return response;
};

//Generate SAST OWASP Response based on Tool Report
export const generateSastOwaspArtifacts = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-sast-owasp-artifacts";
  const response = axios.post(apiUrl, data);
  return response;
};

//DAST SCAN API
export const dastScanAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/scan-web-url";
  const response = axios.post(apiUrl, data);
  return response;
};

//Burp Suite Scan API
export const burpSuiteScanAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/start-burp-scan";
  const response = axios.post(apiUrl, data);
  return response;
};
//GET Scan Details By ScanID
export const getScanDetailsByID = (id) => {
  const apiurl = `${baseUrl.base_url}/QMentisGateway/get-scan-details-by-scanId/${id}`;
  const response = axios.get(apiurl);
  return response;
};

//GET Scan Details By Username
export const getScanDataByUsername = () => {
  const apiurl = `${baseUrl.base_url}/QMentisGateway/get-scan-details-by-username`;
  const response = axios.get(apiurl);
  return response;
};

export const sendBurpSuiteScanByEmail = (scanId) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/send-email-notification/${scanId}`;
  const response = axios.get(apiUrl);
  return response;
};

export const getBurpSuiteScanDetailsByScanID = (scanId) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/get-scan-details-by-scanId/${scanId}`;
  const response = axios.get(apiUrl);
  return response;
};

export const deleteBurpSuiteScan = (scanId) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/delete-burp-scan/${scanId}`;
  const response = axios.delete(apiUrl);
  return response;
};

//Sinlge Run SCAN Analysis
export const singleRunSecurityMetrics = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/single-run-security-metrics`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const singleRunSASTInsightsAndRecs = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/run1-sast-insights-and-recs`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const comparisonRunSecurityMetrics = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/comparison-security-metrics`;
  const response = axios.post(apiUrl, data);
  return response;
};

export const run2InsightsAndRecs = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/generate-run2-insights-and-recs`;
  const response = axios.post(apiUrl, data);
  return response;
};

//Single Run DAST Security Metrics
export const singleRunDASTSecurityMetrics = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/single-run-dast-security-metrics`;
  const response = axios.post(apiUrl, data);
  return response;
};

//Run 2 DAST Insights & Recs Metrics
export const singleRunDASTInsightsAndRecs = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/single-run-dast-insights-recs`;
  const response = axios.post(apiUrl, data);
  return response;
};

//Run 2 DAST Insights & Recs Metrics
export const CompareDASTInsightsAndRecs = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/comparative-dast-insights-recs`;
  const response = axios.post(apiUrl, data);
  return response;
};

//Single Run DAST Security Metrics
export const run2DASTSecurityMetrics = (data) => {
  const apiUrl = `${baseUrl.base_url}/QMentisGateway/run2-dast-security-metrics`;
  const response = axios.post(apiUrl, data);
  return response;
};

//Extract text API from audio/video (user-story)
export const extractTextAPI = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/extractapi/upload-audio-video";
  const response = axios.post(apiUrl, data);
  return response;
};

//Extract text API from audio/video (user-story)
export const extractVideoTextAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/extractapi/upload-video";
  const response = axios.post(apiUrl, data);
  return response;
};

//Extract text API from audio/video (user-story)
export const extractFigmaFileKeyAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/upload-figma";
  const response = axios.post(apiUrl, data);
  return response;
};

//Extract text API from image (user-story)
export const extractTextFromImageAPI = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/upload-image";
  const response = axios.post(apiUrl, data);
  return response;
};

//Validate Candidate Userstory
export const validCandidateUserStory = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/validate-candidate-userstory";
  const response = axios.post(apiUrl, data);
  return response;
};

//Validate Refined Userstory in Test Design
export const evaluateTestDesignReadiness = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/validate-refined-userstory";
  const response = axios.post(apiUrl, data);
  return response;
};

export const uploadKnowledgeBaseDomainSpecificFile = (formData, confirm = false) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisAdminGateway/uploadKnowledgeBaseDomainSpecificFile";
  try {
    // Ensure confirm flag is included in multipart payload
    if (!(formData instanceof FormData)) {
      const fd = new FormData();
      // Best-effort: allow caller to pass plain object
      Object.entries(formData || {}).forEach(([k, v]) => fd.append(k, v));
      formData = fd;
    }
    formData.append("confirm", String(!!confirm));
  } catch (_) {
    // no-op, rely on backend default if append fails
  }
  return axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};


export const uploadKnowledgeBaseArchetypesFile = (formData, confirm = false) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisAdminGateway/uploadKnowledgeBaseArchetypesFile";
  try {
    // Ensure confirm flag is included in multipart payload
    if (!(formData instanceof FormData)) {
      const fd = new FormData();
      // Best-effort: allow caller to pass plain object
      Object.entries(formData || {}).forEach(([k, v]) => fd.append(k, v));
      formData = fd;
    }
    formData.append("confirm", String(!!confirm));
  } catch (_) {
    // no-op, rely on backend default if append fails
  }
  return axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadKnowledgeBaseClientSpecificFile = (formData, confirm = false) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisAdminGateway/uploadKnowledgeBaseClientSpecificFile";
  try {
    // Ensure confirm flag is included in multipart payload
    if (!(formData instanceof FormData)) {
      const fd = new FormData();
      // Best-effort: allow caller to pass plain object
      Object.entries(formData || {}).forEach(([k, v]) => fd.append(k, v));
      formData = fd;
    }
    formData.append("confirm", String(!!confirm));
  } catch (_) {
    // no-op, rely on backend default if append fails
  }
  return axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const CagLocatorsGeneration = (data) => {
  console.log(data, "in serviceeeee");

  const apiUrl = baseUrl.base_url + "/QMentisGateway/cag-generate-locators";
  const response = axios.post(apiUrl, data);
  return response;
};

export const FrameworkBasedLocatorsGeneration = (data) => {
  console.log(data, "in framework service");

  const apiUrl = baseUrl.base_url + "/QMentisGateway/framework-based-generate-locators";
  const response = axios.post(apiUrl, data);
  return response;
};

// export const mavenProjectWithToolCalling = (data, framework) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };

// export const mavenProjectWithToolCalling = (data, framework) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };
// export const mavenProjectWithToolCalling = (data, framework) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };
// export const mavenProjectWithToolCalling = (data, framework) => {
//   const apiUrl =
//     baseUrl.base_url + `/QMentisGateway/generate-mavenProject-selenium-java-with-tool-calling`;
//   const response = axios.post(apiUrl, data);
//   return response;
// };

export const mavenProjectRestassuredWithToolCalling = (data, framework) => {
  const apiUrl =
    baseUrl.base_url +
    `/QMentisGateway/generate-mavenProject-restassured-with-tool-calling`;
  const response = axios.post(apiUrl, data);
  return response;
};
export const updateGitHubProjectRestAssuredJava = (data) => {
  // console.log(data,"in serviceee");
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/update-github-project-restassured-java";
  const response = axios.post(apiUrl, data);
  return response;
};

/***** Get User by Email *****/
export const getUserByEmail = async () => {
  const getUserUrl = `${baseUrl.base_url}/getUserByEmail`;

  try {
    const response = await axios.get(getUserUrl);
    return response;
  } catch (error) {
    console.error("Error fetching user by email:", error);
    throw error;
  }
};

/***** Change Password *****/
export const changePassword = async (data) => {
  const changePasswordUrl = `${baseUrl.base_url}/change-password`;

  try {
    const response = await axios.post(changePasswordUrl, data);
    return response;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

/*************QE STRATEGY *****************/

//For storing the full structured CSV in the dB
export const storeCsvDataInDB = async (blob, filename) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/upload-CSV-to-DB";

  const formData = new FormData();
  formData.append("file", blob, filename);

  const response = await axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};

// For extracting the keywords from the uploaded documents
export const uploadDocumentToTransformer = (files, urls = []) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/upload-QEStrategy-file-to-transformer";

  const formData = new FormData();

  // Loop through each file and append it to the formData
  if (files && files.length > 0) {
    files.forEach((file) => {
      formData.append("files", file);
    });
  }

  // Append URLs
  if (urls && urls.length > 0) {
    formData.append("website_URL", urls.join(","));
  }

  // Make one single API call with all the files
  return axios.post(apiUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadCombinedDocumentToTransformer = (formData) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/upload-combined-file-to-transformer";

  return axios.post(apiUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const advisoryLayerExecutable = (file) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/advisory-layer";
  const response = axios.post(apiUrl, file);
  return response;
};


// For extracting the keywords from Video
export const videoToAudioTotext = (file) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/videoToAudio-To-Text-ByTransformer";

  const formData = new FormData();
  formData.append("video", file); // <-- 'video' must match multer field name

  return axios.post(apiUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// For extracting text from image
export const imageTotext = (file) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/imageTotext-ByTransformer";

  const formData = new FormData();
  formData.append("image", file); // <-- 'image' must match multer field name

  return axios.post(apiUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// For converting the unstructured text to Structured  format
export const convertUnstructuredTextToStructured = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/sendInputText-to-transformer";
  const response = axios.post(apiUrl, data);
  return response;
};

// for predicting the archetype
export const archetypePredictor = (data) => {
  const apiUrl = baseUrl.base_url + "/QMentisGateway/archetypePredictor";
  const response = axios.post(apiUrl, data);
  return response;
};

// For Web Scraping
export const sendScrapingURLToTransformer = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/sendrequiredURL-to-transformer";
  const response = axios.post(apiUrl, data);
  return response;
};

export const updateGitHubProjectPlaywrightTypeScript = (data) => {
  const apiUrl =
    baseUrl.base_url + "/QMentisGateway/generate-newProject-Github";
  const response = axios.post(apiUrl, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

/***** Performance Testing Requirements *****/
export const savePerformanceTestingRequirements = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisGateway/save-requirements`,
    data
  );
};

export const getPerformanceTestingRequirements = (userId) => {
  return axios.get(
    `${baseUrl.base_url}/QMentisGateway/get-requirements?user_id=${userId}`
  );
};

export const submitPerformanceTestingRequirements = (data) => {
  return axios.post(
    `${baseUrl.base_url}/QMentisGateway/submit-requirements`,
    data
  );
};

